import React, { useRef, useCallback, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PdfViewerComponent, Toolbar, Magnification, Navigation,
    LinkAnnotation, BookmarkView, ThumbnailView, Print,
    TextSelection, Annotation, TextSearch, FormFields,
    FormDesigner, PageOrganizer, Inject } from '@syncfusion/ej2-react-pdfviewer';
import OuraNav from "../components/OuraNav";
import fetchBase from "../utils/fetchBase";


export default function HubDocumentViewerPage() {
    const { hubId, sectionId, documentId } = useParams();
    const navigate = useNavigate();
    const viewerRef = useRef(null);
        const token = localStorage.getItem("jwt_token");
        const documentUrl = `${fetchBase}/api/document-hub/documents/${documentId}/file`;

                    const freeTextActive = useRef(false);
                    const saveTimeoutRef = useRef(null);
                    const [saveStatus, setSaveStatus] = useState(null); // null | "saving" | "saved" | "error"



                    const performSave = useCallback(async () => {
                        if (!viewerRef.current) return;
                        const startedAt = Date.now();
                        try {
                            const blob = await viewerRef.current.saveAsBlob();

                                const formData = new FormData();
                                formData.append("file", blob, "document.pdf");

                                const res = await fetch(`${fetchBase}/api/document-hub/documents/${documentId}/save`, {
                                    method: "POST",
                                    headers: { Authorization: `Bearer ${token}` },
                                    body: formData
                                });

                                const elapsed = Date.now() - startedAt;
                                const minVisibleMs = 600;
                                if (elapsed < minVisibleMs) {
                                    await new Promise(resolve => setTimeout(resolve, minVisibleMs - elapsed));
                                }

                                setSaveStatus(res.ok ? "saved" : "error");
                            } catch (err) {
                                console.error("Autosave failed:", err);
                                setSaveStatus("error");
                            }
                        }, [documentId, token]);


                    const scheduleAutosave = useCallback(() => {
                        setSaveStatus("saving");
                        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
                        saveTimeoutRef.current = setTimeout(() => {
                            performSave();
                        }, 400);
                    }, [performSave]);

                    useEffect(() => {
                        const handleDocumentClick = (e) => {
                            const target = e.target.closest("button, [role='button']");
                            if (!target) return;
                            const text = target.textContent?.trim().toLowerCase();
                            if (text === "save") {
                                // Give the viewer a moment to finish merging the page-organizer
                                // change into the live document before we read it via saveAsBlob().
                                setTimeout(() => {
                                    scheduleAutosave();
                                }, 800);
                            }
                        };

                        document.addEventListener("click", handleDocumentClick, true);
                        return () => document.removeEventListener("click", handleDocumentClick, true);
                    }, [scheduleAutosave]);






                        const handleToolbarClick = useCallback((args) => {
                            if (args?.item?.id?.toLowerCase().includes("freetext") ||
                                args?.item?.tooltipText?.toLowerCase().includes("free text")) {
                                freeTextActive.current = true;
                            } else {
                                freeTextActive.current = false;
                            }
                        }, []);



                        const handleAnnotationAdded = useCallback((args) => {
                            if (args?.annotationType === "FreeText") {
                                setTimeout(() => {
                                    if (viewerRef.current && freeTextActive.current) {
                                        viewerRef.current.annotation.setAnnotationMode("FreeText");
                                    }
                                }, 150);
                            }
                            scheduleAutosave();
                        }, [scheduleAutosave]);

                        const handleAnnotationDeselected = useCallback(() => {
                            if (freeTextActive.current && viewerRef.current) {
                                setTimeout(() => {
                                    if (freeTextActive.current && viewerRef.current) {
                                        viewerRef.current.annotation.setAnnotationMode("FreeText");
                                    }
                                }, 150);
                            }
                        }, []);

                        const handleFormFieldFocusOut = useCallback(() => {
                            scheduleAutosave();
                        }, [scheduleAutosave]);

                        const handleAnnotationPropertiesChange = useCallback(() => {
                            scheduleAutosave();
                        }, [scheduleAutosave]);

                            const handleAddSignature = useCallback(() => {
                                scheduleAutosave();
                            }, [scheduleAutosave]);

                                    const handlePageOrganizerSaveAs = useCallback(async (args) => {
                                        console.log("pageOrganizerSaveAs args:", args);
                                        try {
                                            setSaveStatus("saving");


                                    const base64 = args.downloadDocument.split(",")[1] || args.downloadDocument;
                                    const byteString = atob(base64);
                                    const byteArray = new Uint8Array(byteString.length);
                                    for (let i = 0; i < byteString.length; i++) {
                                        byteArray[i] = byteString.charCodeAt(i);
                                    }
                                    const blob = new Blob([byteArray], { type: "application/pdf" });

                                    const formData = new FormData();
                                    formData.append("file", blob, "document.pdf");

                                    const res = await fetch(`${fetchBase}/api/document-hub/documents/${documentId}/save`, {
                                        method: "POST",
                                        headers: { Authorization: `Bearer ${token}` },
                                        body: formData
                                    });

                                    setSaveStatus(res.ok ? "saved" : "error");
                                } catch (err) {
                                    console.error("Page organizer save failed:", err);
                                    setSaveStatus("error");
                                }
                            }, [documentId, token]);




                        const handleAnnotationRemoved = useCallback(() => {
                            scheduleAutosave();
                        }, [scheduleAutosave]);


    return (
        <div style={{ backgroundColor: "#f2f2f7", minHeight: "100vh" }}>
            <OuraNav links={[
                { label: "Dashboard", href: "/admin-dashboard" },
                { label: "Employees", href: "/employees" },
                { label: "Clients", href: "/admin/clients" },
                { label: "Scheduler", href: "/scheduler" },
                { label: "Payroll", href: "/admin/payroll" }
            ]} />

            <div style={{ maxWidth: 1200, margin: "0 auto", padding: "40px 40px" }}>
                <div style={{ fontSize: "13px", color: "#6e6e73", marginBottom: "24px", display: "flex", alignItems: "center", gap: "6px" }}>
                    <span onClick={() => navigate("/document-hub")} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>Document Hub</span>
                    <span>›</span>
                    <span onClick={() => navigate(`/document-hub/${hubId}`)} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>Hub</span>
                    <span>›</span>
                    <span onClick={() => navigate(`/document-hub/${hubId}/sections/${sectionId}`)} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>Section</span>
                    <span>›</span>
                    <span style={{ color: "#1d1d1f", fontWeight: "500" }}>Document</span>
                </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                        {saveStatus && (
                            <span style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                color: saveStatus === "error" ? "#ff3b30" : "#6e6e73"
                            }}>
                                {saveStatus === "saving" && "Saving..."}
                                {saveStatus === "saved" && "Saved"}
                                {saveStatus === "error" && "Save failed"}
                            </span>
                        )}

                        <button
                            onClick={() => viewerRef.current && viewerRef.current.download()}
                            style={{ padding: "9px 20px", backgroundColor: "#1d1d1f", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
                        >
                            Download PDF
                        </button>
                    </div>


                <div style={{ height: "85vh", borderRadius: "12px", overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.1)" }}>
                    <PdfViewerComponent
                          ref={viewerRef}
                          id="hub-pdf-viewer"
                          documentPath={documentUrl}
                          ajaxRequestSettings={{
                              ajaxHeaders: [{ headerName: "Authorization", headerValue: `Bearer ${token}` }]
                          }}
                          resourceUrl="https://cdn.syncfusion.com/ej2/dist/ej2-pdfviewer-lib"
                          style={{ height: "100%", display: "block" }}
                          enableFormFields={true}
                            enableFreeText={true}
                            toolbarClick={handleToolbarClick}
                            annotationAdd={handleAnnotationAdded}
                            annotationDeselect={handleAnnotationDeselected}
                            annotationRemove={handleAnnotationRemoved}
                            annotationPropertiesChange={handleAnnotationPropertiesChange}
                            formFieldFocusOut={handleFormFieldFocusOut}
                            addSignature={handleAddSignature}
                            pageOrganizerSaveAs={handlePageOrganizerSaveAs}




                      >

                        <Inject services={[Toolbar, Magnification, Navigation, Annotation,
                            LinkAnnotation, BookmarkView, ThumbnailView, Print,
                            TextSelection, TextSearch, FormFields, FormDesigner, PageOrganizer]} />
                    </PdfViewerComponent>
                </div>
            </div>
        </div>
    );
}